import { BASE_URL } from '../../../../../utils/config.base-url'

export const DOCUMENT_PERMISSION_ROLE_PREFIX_URL = '/document-permission-role'
export const URL_ENDPOINT_DOCUMENT_PERMISSION_ROLE = `${BASE_URL}/document-permission-role`
